export default {
  user:    'user',
  network: 'network'
}
